import { getSearchParams } from '@bnnvara/helpers';

/** Only retrieve parts of the form fields in favor of privacy */
export function donationParams() {
  const params = getSearchParams();

  return {
    firstName: params.get('firstName'),
    middleName: params.get('middleName'),
    lastName: params.get('lastName'),
    email: params.get('email'),
    period: params.get('period'),
  };
}
